import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import CreateIcon from "@mui/icons-material/Create";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LaunchIcon from "@mui/icons-material/Launch";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { selectPatient } from "../../../../store/Profiles/PatientMapSelectSlice";

const PatientActions = ({ cipId, onAssignTask, onClick }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        ⚙️ Actions
      </Typography>

      <Grid container spacing={2}>
        {/* Asignar tarea */}
        <Grid item xs={12} sm={6}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            startIcon={<AssignmentIndIcon />}
            onClick={() => onAssignTask(cipId.varCipId)}
          >
            Assign Task
          </Button>
        </Grid>

        {/* Crear perfil */}
        <Grid item xs={12} sm={6}>
          <Button
            fullWidth
            variant="outlined"
            color="info"
            startIcon={<CreateIcon />}
            onClick={() => {
                navigate("/profile")
                onClick()  
              }
            }
          >
            Create Profile
          </Button>
        </Grid>

        {/* Crear Care Plan */}
        <Grid item xs={12} sm={6}>
          <Button
            fullWidth
            variant="outlined"
            color="secondary"
            startIcon={<FavoriteIcon />}
            onClick={() => {
              navigate(`/create-care-plan/${cipId.varCipId}`)
              onClick()  
            }
          }
          >
            Create Care Plan
          </Button>
        </Grid>

        {/* Ir al detalle completo */}
        <Grid item xs={12} sm={6}>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<LaunchIcon />}
            onClick={() => {
              dispatch(selectPatient({ PatientSelect: cipId}));
              navigate(`/patient-detail/${cipId.varCipId}`)
              onClick()
            }}
          >
            Full Patient Detail
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PatientActions;
